import React from "react";
import { IconContextProvider, IconProps } from "@kernel/react-icons";
import {
  INotificationHandler,
  NotificationToastBuilder,
  Notificator,
  ToastPosition
} from "@kernel/react-ui-kit";
import { icons } from "@kernel/icon-set-essentials";

export interface NotificationHandlerProps {
  body: string;
  header: string;
}

export class NotificationHandler
  implements INotificationHandler<NotificationHandlerProps>
{
  public icon: IconProps;
  private readonly noticator: Notificator;
  private constructor(position: ToastPosition, private delay: number = 5000) {
    this.noticator = Notificator.create(
      "notifications",
      {
        position,
        className: "pmmon__app-toaster-notifications"
      },
      (children) => (
        <IconContextProvider icons={icons}>{children}</IconContextProvider>
      )
    );
    this.icon = {
      set: "bs",
      icon: "bell-fill"
    };
  }

  public handle(props: NotificationHandlerProps): void {
    const toast = new NotificationToastBuilder()
      .withAutohide()
      .withIcon(this.icon)
      .withBody(props.body)
      .withHeader(props.header)
      .withDelay(this.delay)
      .withAnimation()
      .build()
      .toast();
    this.noticator.show(toast);
  }

  public static create(
    position: ToastPosition = "top-end",
    delay = 5000
  ): NotificationHandler {
    return new NotificationHandler(position, delay);
  }
}
